import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=43a65ac6"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"
import style0 from "./Notices.vue?vue&type=style&index=0&id=43a65ac6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../../Users/tony.yu/Documents/asd-tmm-client-vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
